import { 
    ContentWrapper, 
    BoxWrapper, 
    ConditionalWrapper,
    FlexWrapper
} from "../../components/Wrappers/Wrappers"
import { useState, useEffect } from "react"
import { Text, Title, DetailText } from "../../components/units/Text"
import { Divider } from "../../components/units/Divider"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useParams } from "react-router-dom"
import { 
    Acb,
    AcbPatch,
    AxiosGetAcb,
    AxiosPatchAcb
} from "../../components/Rest/RestPatchAcb"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../components/Rest/Organization"
import { LgSelect } from "../../components/Form/FormInput"
import { useValidatePermission } from "../../roles/roles"
import { hasPermission } from "../../roles/roles"

interface ResponseProps {
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | undefined;
}





export const AcbEditView = ():JSX.Element => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()
    useValidatePermission({role: user.role, resource: 'AcbView', action: 'editBtn'})
    if (!serial_number) {
        throw "serial number must be provided"
    }

    useEffect(() => {
        AxiosGetAcb(user.role_slug, serial_number, setAcb)
    }, [])

    const [acb, setAcb] = useState<Acb>({
        building_id: null,
        client_device_type: null,
        custom_name: null,
        customer_comment: null,
        serial_number: serial_number,
        buildings: [],
        devices: []
    })
    const [response, setResponse] = useState<ResponseProps>({
        requestState: RestApiState.Idle,
        timeOutId: undefined
    })

    const handleSubmit = (event: any) => {
        event.preventDefault();
        setResponse(prev => ({...prev, errors:{}}))

        const formData = new FormData(event.currentTarget)
        const formValues: Record<string, any> = {};
        formData.forEach((value, key) => {
            formValues[key] = value as any; // Cast value to string if necessary
            // if (key in changes) {
                
            // } 
        });

        setResponse(prev => ({...prev, requestState: RestApiState.Pending}))
        AxiosPatchAcb(
            user.role_slug,
            serial_number,
            formValues as AcbPatch, 
            setAcb,
            (value: RestApiState) => {
                setResponse(prev => ({...prev, requestState: value}))
            }
        )
    }

    return (
        <ContentWrapper>
            <DetailText href={`/react/acb/detail/${serial_number}`}> Назад </DetailText>
            <Title>Общие сведения</Title>
            <br />
            <BoxWrapper 
                bg="bg-primary"
                p="p2"
                r="r10"
                style={{
                    maxWidth: "640px"
                }} 
            >
            { acb && (
                <form onSubmit={ handleSubmit } className="show-up-quick">
                    <Input name="custom_name"
                        label="Свое название"
                        required={false}
                        type='text'
                        value={acb.custom_name ? acb.custom_name : ''}
                        disabled={false}
                        setter={ (e:any) => { 
                            setAcb(prev => ({...prev, custom_name: e.target.value}))}
                        }
                    />
                    <Input name="customer_comment"
                        label="Свой комментарий"
                        required={false}
                        type='text'
                        value={acb.customer_comment ? acb.customer_comment : ''}
                        disabled={false}
                        setter={ (e:any) => { 
                            setAcb(prev => ({...prev, customer_comment: e.target.value}))}
                        }
                    />
                    <LgSelect name={"client_device_type"}
                        label="Вид техники"
                        value={acb.client_device_type ? acb.client_device_type : undefined}
                        options={[
                            {value: '', label: "Не выбрано"},
                            ...acb.devices.map(item => ({
                            value: item.id,
                            label: item.device_name ? item.device_name : '',
                        }))]}
                        valueSetter={ (e:any) => { 
                            console.log(e.target.value)
                            setAcb(prev => ({...prev, client_device_type: e.target.value}))}
                        }
                        />

                    <LgSelect name={"building_id"}
                        label="Объект"
                        value={acb.building_id ? acb.building_id : undefined}
                        options={[
                            {value: '', label: "Не выбрано"},
                            ...acb.buildings.map(item => ({
                            value: item.id,
                            label: item.building_name ? item.building_name : '',
                        }))]}
                        valueSetter={ (e:any) => { 
                            setAcb(prev => ({...prev, building_id: e.target.value}))}
                        }
                    />
                    <SubmitButton 
                        restState={response.requestState}
                        disabled={false}
                        restHandler={{
                            timeOutId: null,
                            setter: (key: "timeOutId" | "requestState", value: any) => {
                                setResponse(prev => ({...prev, [key]: value}))
                            }
                        }}
                    />
                </form>
            ) }
            { hasPermission({role: user.role, resource: 'AcbView', action: 'changeOrganization'}) && (
                <BoxWrapper>
                    <FlexWrapper alignItems="center" className="full-width" justifyContent="center">
                        <DetailText href={`/react/acb/${serial_number}/change-organization`} className="underline pointer">
                            Сменить организацию
                        </DetailText>
                    </FlexWrapper>
                </BoxWrapper>
            ) }
            
            </BoxWrapper>
        </ContentWrapper>
    )
}